import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showSuccessToast = (message = 'Success!') => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 9000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });
};

export const showErrorToast = (message = 'Something went wrong!') => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 9000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });
};

// In your App.js (or root), add once:
// import { ToastContainer } from 'react-toastify';
// <ToastContainer />
